import { isMobileBrowser } from '@rover/utilities/device';
import geoHTML5Lookup from './geoHTML5Lookup';

import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';

export default {
  init(successCallback) {
    if (isMobileBrowser()) {
      geoHTML5Lookup(successCallback);
    } else {
      $('.js-location-input').locationpicker({
        onlyNonNumeric: true,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./js/utilities/GeoLocation.js